module.exports = __webpack_public_path__ + "static/media/whitecheck_new.1fc621ec.svg";